export default {
  "41b6a55924934f9561d4165c8fd92f24": "打印日誌：跳轉到UC情況下的路由1",
  "847f8d220f682601c17e64136e1cd019": "打印日誌：跳轉到UC情況下的路由2",
  "2a5e8edf4cc6c6e8f83c749055ad0380": "商品詳情"
}
